/* Keep background video playing, everywhere, without any visible control.

   Muted inline video is supposed to autoplay. Three things stop it:

     - iOS Low Power Mode and Low Data Mode block autoplay outright, whatever
       the markup says
     - a tab restored from the background comes back with media paused
     - a play() that was in flight when something reset the element is dropped

   Rather than show a play button, this listens for the first real interaction
   of any kind - touch, pointer, key, scroll - and retries every paused muted
   video at that moment. A user gesture grants media permission for the page,
   so the retry succeeds where the automatic attempt did not, and the visitor
   never sees a control or knows anything was refused.

   It also re-checks whenever the tab becomes visible again, and watches for
   videos that quietly pause themselves mid-session. Videos the visitor has
   deliberately paused are left alone: only muted, autoplay-marked background
   video is ever touched. */
(function(){
  'use strict';

  /* --- Poster images inside <video> -------------------------------------
     Shopify's video_tag filter emits a poster <img> with no alt attribute at
     all, which is the one genuine alt-text gap left on the site and the thing
     an accessibility audit flags. It is decorative - it is the still frame of
     a background video that carries no information of its own - so the correct
     value is an empty alt, which tells a screen reader to skip it rather than
     read out a filename. Nothing else on the page is touched. */
  function markPosters(){
    var posters = document.querySelectorAll('video > img:not([alt])');
    for(var i = 0; i < posters.length; i++){ posters[i].setAttribute('alt', ''); }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markPosters);
  else markPosters();
  window.addEventListener('load', markPosters);

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(RM) return;

  function candidates(){
    return [].slice.call(document.querySelectorAll('video[autoplay]'))
      .filter(function(v){ return v.muted && v.paused; });
  }

  function visible(v){
    var r = v.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || 0) &&
           r.right > 0 && r.left < (window.innerWidth || 0);
  }

  function start(v){
    var p;
    try{ p = v.play(); }catch(e){ return; }
    if(p && p.catch) p.catch(function(){});
  }

  function nudge(){
    candidates().forEach(function(v){
      /* Off-screen video is left alone - the browser is right to hold it, and
         forcing it wastes bandwidth and battery. */
      if(visible(v)) start(v);
    });
  }

  /* --- Park video that has scrolled away --------------------------------

     Measured on the homepage: the hero video keeps decoding for the whole
     15,800px of the page, long after it is thousands of pixels behind you.
     A decoding video holds a compositor layer and a decode pipeline open, and
     on an iPhone that is precisely the memory pressure that makes the browser
     discard and re-rasterise layers mid-scroll - what reads as the page
     jumping on the way back up.

     Parked a full screen after it leaves and resumed a full screen before it
     returns, so the visitor never sees a stopped frame. dataset.kupHeld marks
     that WE parked it, so video paused for any other reason is never restarted
     behind the visitor's back.

     The Farm to KUP scenes are excluded. kup-doc.js runs that sequence and
     keeps exactly one scene live at a time already; two owners for the same
     element is how the earlier AbortError was caused. */
  var io = null;
  function managedElsewhere(v){ return !!(v.closest && v.closest('.kup-dscene')); }

  if('IntersectionObserver' in window){
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        var v = e.target;
        if(e.isIntersecting){
          if(v.paused && v.dataset.kupHeld === '1'){
            delete v.dataset.kupHeld;
            start(v);
          }
        } else if(!v.paused){
          v.dataset.kupHeld = '1';
          try{ v.pause(); }catch(err){}
        }
      });
    }, { rootMargin: '100% 0px 100% 0px', threshold: 0 });
  }

  var watched = [];
  function watch(){
    if(!io) return;
    [].slice.call(document.querySelectorAll('video[autoplay]')).forEach(function(v){
      if(!v.muted || managedElsewhere(v) || watched.indexOf(v) !== -1) return;
      watched.push(v);
      io.observe(v);
    });
  }

  var unlocked = false;
  function unlock(){
    if(unlocked) return;
    unlocked = true;
    nudge();
    ['pointerdown','touchstart','keydown','scroll'].forEach(function(t){
      window.removeEventListener(t, unlock, true);
    });
  }

  ['pointerdown','touchstart','keydown','scroll'].forEach(function(t){
    window.addEventListener(t, unlock, {capture:true, passive:true});
  });

  document.addEventListener('visibilitychange', function(){
    if(!document.hidden) nudge();
  });

  /* A light periodic check catches anything that pauses itself - iOS does this
     after certain interruptions - without polling hard enough to cost battery.
     Anything parked above is skipped, so the two never fight. */
  setInterval(function(){
    if(document.hidden || !unlocked) return;
    candidates().forEach(function(v){
      if(v.dataset.kupHeld === '1') return;
      if(visible(v)) start(v);
    });
    watch();
    markPosters();
  }, 4000);

  function boot(){ nudge(); watch(); markPosters(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', boot);
})();
